import {qtyProxy} from "../../../index";
import { AlignObjectPosition } from "../productConfiguration/util/alignObjectPosition";


export const addTextHTMLHandler = () => {
  return `
        <div class="text-customisation-main" id="textEditorBox">
          <div class="show-selected-text">
              <input type="text" id="selectedText"/>
          </div>

          <div class="text-customisation">
              <div class="customisation-option">
                  <select id="fontType">
                      <option value="Times-New-Roman" style="font-family: 'Times-New-Roman'">Times New Roman</option>
                      ${qtyProxy?.fontList?.map((fontData)=>{
                          return`
                        <option style="font-family: ${fontData.family}" value=${fontData.family.replaceAll(" ", "-")}>${fontData.family}</option>
                          `
                        }).join("")}
                  </select>
                  <label for="fontType">Font Type</label>
              </div>

              <div class="customisation-option">
                  <input type="number" id="fontSize" value="24" min="1"/>
                  <label for="fontSize">Font Size</label>
              </div>

              <div class="customisation-option">
                  <input type="color" id="textColor" value="#000000" />
                  <label for="textColor">Color</label>
              </div>

              <div class="customisation-option">
                  <input type="checkbox" id="fontBold" value="Bold"/>
                  <label for="fontBold" class="bold-font" id="boldFontLabel">B</label>
                  <label for="fontBold">Bold</p>
              </div>

              <div class="customisation-option">
                  <input type="checkbox" id="fontItalic" value="Italic" />
                  <label for="fontItalic" class="italic-font" id="italicFontLabel">I</label>
                  <label for="fontItalic">Italic</label>
              </div>

              <div class="customisation-option">
                  <input type="checkbox" id="fontUnderline" value="underline" />
                  <label for="fontUnderline" class="underline-font" id="underlineFontLabel">U</label>
                  <label for="fontUnderline">UnderLine</label>
              </div>

              <div class="customisation-option">
                  <select id="textAlign">
                      <option value="left">Left</option>
                      <option value="center">Center</option>
                      <option value="right">Right</option>
                  </select>
                  <label for="textAlign">Text Alignment</label>
              </div>
          </div>
          <div class="input-group text-rotation-wrapper">
            <label for="logoRotationDegree">Angle of Rotation: </label>
            <input min="1" type="number" class="logoRotationDegree" value="${0}" />
          </div>
          ${AlignObjectPosition()}
        </div>`;
};
